import Vue from 'vue';
import Router from 'vue-router';
import ExamManageRoutes from '@/modules/exam-manage/routes';
import ExamReportRoutes from '@/modules/exam-report/routes';
import ExamReportNewRoute from '@/modules/exam-report-new/routes';
import PaperMarkingRoutes from '@/modules/paper-marking/routes';
import ManageCenterRoutes from '@/modules/manage-center/routes';
import AffairManageRoutes from '@/modules/affair-manage/routes';
import ErrorHandler from '@/modules/error-handler/routes';
import { localStoragePrefix } from '@/scripts/utils';
import store from '../store/index';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Login',
      },
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('@/modules/login/NewLogin.vue'),
      // component: () => import('@/modules/login/NewLogin2.vue'),
    },
    {
      path: '/ReportSetting',
      name: 'ReportSetting',
      component: () => import('@/modules/report-setting/ReportSetting.vue')
    },
    {
      path: '/MarkingSupervision',
      name: 'MarkingSupervision',
      component: () => import('@/modules/affair-manage/evaluationManage/supervision.vue'),
    },
    {
      path: '/MainPage',
      component: () => import('@/pages/MainPage.vue'),
      children: [
        {
          path: '',
          redirect: 'homePage',
        },
        {
          path: 'homePage',
          name: 'homePage',
          component: () => import('@/modules/home-page/HomePage2.vue'),
        },
        {
          path: 'answer-sheet-center',
          name: 'answerSheetCenter',
          component: () => import('@/modules/answer-sheet-center/AnswerSheetCenter.vue'),
        },
        // 查分
        {
          path: 'searchScore/:exam_no/:exam_id',
          name: 'SearchScore',
          meta: { hideMainNav: true },
          component: () => import('@/modules/search-score/ViewScore.vue'),
        },
        {
          path: 'teachingSupervision',
          name: 'teachingSupervision',
          component: () => import('@/modules/teaching-supervision/TeachingSupervision.vue'),
        },
        ExamManageRoutes,
        AffairManageRoutes,
        ...ExamReportRoutes,
        ExamReportNewRoute,
        PaperMarkingRoutes,
        ManageCenterRoutes,
        ErrorHandler,
        {
          path: 'paper',
          name: 'paper',
          component: () => import('@/pages/Paper.vue'),
        },
        {
          path: 'permission',
          name: 'permission',
          redirect: '/MainPage/permission/role-permission',
        },
        {
          path: 'permission/role-permission',
          name: 'rolePermission',
          component: () => import('@/pages/permission/RolePermission.vue'),
        },
        {
          path: 'permission/data-rule',
          name: 'dataRule',
          component: () => import('@/pages/permission/DataRule.vue'),
        },
        {
          path: 'permission/period-scope',
          name: 'periodScope',
          component: () => import('@/pages/permission/PeriodScope.vue'),
        },
        {
          path: 'threeYearsQuestions',
          name: 'threeYearsQuestions',
          component: () => import('@/pages/ThreeYearsQuestions.vue'),
        },
        {
          path: 'helpCenter',
          name: 'HelpCenter',
          component: () => import('@/modules/home-page/HelpCenter.vue'),
          children: [
            {
              path: '',
              redirect: 'downloadCenter',
            },
            {
              path: 'introduction',
              name: 'Introduction',
              component: () => import('@/modules/home-page/components/ProductIntroduction.vue'),
            },
            {
              path: 'downloadCenter',
              name: 'DownloadCenter',
              component: () => import('@/modules/home-page/components/DownloadCenter.vue'),
            },
          ]
        }
      ],
    },
    {
      path: '/marking',
      name: 'marking',
      component: () => import('@/pages/marking.vue'),
    },
    {
      path: '/marking-view',
      name: 'MarkingView',
      component: () => import('@/modules/marking-task/views/MarkingView.vue'),
    },
    {
      path: '/adjust-coord/:examId/:subjectId/:type/:questionId',
      name: 'AdjustCoord',
      component: () => import("@/modules/adjustPaperCoord/adjustCoord.vue")
    },
    // 下面的路由可能有特殊用途，但是没找到相关文档
    {
      path: '/setDistri',
      name: 'setDistri',
      component: () => import('@/components/markset/setDistri.vue'),
    },
    {
      path: '/back',
      name: 'back',
      component: () => import('@/pages/back.vue'),
    },
    {
      path: '/MarkSet',
      name: 'MarkSet',
      component: () => import('@/pages/MarkSet.vue'),
    },
    {
      path: '/ClassesManager',
      name: 'ClassesManager',
      component: () => import('@/modules/class-page/ClassesManager.vue'),
    },
    {
      path: '/changeAnswer',
      name: 'changeAnswer',
      component: () => import('@/pages/changeAnswer.vue'),
    },
    {
      path: '/changeMarker',
      name: 'changeMarker',
      component: () => import('@/pages/changeMarker.vue'),
    },
    {
      path: '/studentScoresList',
      name: 'studentScoresList',
      component: () => import('@/pages/studentScoresList.vue'),
    },
    {
      path: '/ClassReport',
      name: 'ClassReport',
      component: () => import('@/modules/exam-report/components/class-report/ClassReport.vue'),
    },
    {
      path: '/bindQuestions',
      name: 'bindQuestions',
      component: () => import('@/pages/bindQuestions.vue'),
    },
    {
      path: '/toolsBox',
      component: () => import('@/pages/toolsBox.vue'),
      children: [
        {
          path: '',
          redirect: '',
        },
        {
          path: 'toolsPage',
          name: 'toolsPage',
          component: () => import('@/components/toolsBox/toolsPage.vue'),
        },
      ],
    },
    {
      path: '/toolCheck',
      name: 'toolCheck',
      component: () => import('@/components/unuse/toolCheck.vue'),
    },
  ],
  // 跳转到新路由时开始位置总在顶端
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  if (from.meta.keepAlive) {
    const $main = document.querySelector(from.meta.scrollEl);
    const scrollTop = $main ? $main.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
  }
  const { user_id, token, school_id } = to.query;
  if (user_id) {
    sessionStorage.setItem(`${localStoragePrefix}user_id`, user_id);
  }
  if (school_id) {
    sessionStorage.setItem(`${localStoragePrefix}user_school_id`, school_id);
  }
  if (token) {
    sessionStorage.setItem(`${localStoragePrefix}session_token`, token);
  }
  if (from.fullPath === '/' && to.name === 'unfinishList') {
    const {
      userId, userName, userRole, userSchoolId,
    } = to.query;
    if (userId) {
      sessionStorage.setItem(`${localStoragePrefix}user_id`, userId);
      sessionStorage.setItem(`${localStoragePrefix}user_name`, userName);
      sessionStorage.setItem(`${localStoragePrefix}user_school_id`, userSchoolId);
      sessionStorage.setItem(
        `${localStoragePrefix}type`,
        userRole === '8' ? 999 : 0,
      );
      next();
      return;
    }
  }
  // 给综合服务平台跳转
  if (to.query.from === 'service' && to.path.includes('overview')) {
    sessionStorage.setItem(`${localStoragePrefix}type`, 999);
  }

  if (to.fullPath.includes('markPaper')) {
    store.commit('updateCurrentRouteName', '考试阅卷');
  } else if (to.fullPath.includes('error-home')) {
    store.commit('updateCurrentRouteName', '异常处理中心');
  }

  const userType = +window.sessionStorage.getItem(`${localStoragePrefix}type`);
  const userId = sessionStorage.getItem(`${localStoragePrefix}user_id`);

  // 跳往登录界面不做限制
  if (to.name === 'Login') {
    next();
    return;
  }

  // 用户没有登陆的时候 即使通过路由输入地址 也要跳转到login界面
  if (
    (typeof userId === 'undefined' || userId === null)
    && to.name !== 'Login'
  ) {
    next({
      name: 'Login',
    });
    return;
  }

  // 当用户不为999 让用户跳到阅卷任务 不跳到阅卷管理
  // if (userType !== 999 && to.name === 'overview') {
  //   next({
  //     name: 'unfinishList',
  //   });
  //   return;
  // }

  next();
});

export default router;
